import { Link } from 'react-router-dom';

export function Privacy() {
  return (
    <article className="mx-auto max-w-screen-md px-6 py-10 text-text-primary">
      <Link to="/" className="text-xs text-text-muted underline">← Home</Link>
      <h1 className="mt-4 text-2xl font-medium">Privacy</h1>
      <p className="mt-3 text-sm text-text-muted">
        Nudge stores the minimum needed to make the product work: your display name, the contents of cards you create, the cards you've sent, and your push subscription if you opt in. We do not sell or share your data.
      </p>
      <h2 className="mt-6 text-base font-medium">What we collect</h2>
      <p className="mt-2 text-sm text-text-muted">Display name, device identifier, settings, circle membership, cards (templates and sent), and acknowledgments.</p>
      <h2 className="mt-6 text-base font-medium">Retention</h2>
      <p className="mt-2 text-sm text-text-muted">Sent cards are auto-deleted after 7 days. You can delete your account at any time, which removes your data immediately.</p>
      <h2 className="mt-6 text-base font-medium">Contact</h2>
      <p className="mt-2 text-sm text-text-muted">Email <a className="underline" href="mailto:hi@nudgeapp.example">hi@nudgeapp.example</a> with questions.</p>
    </article>
  );
}
